module.exports = __webpack_public_path__ + "static/media/breastSurgery-image3@3x.83d854cb.png";